import React, { useState, useEffect } from "react";

import { GetScheduleMNGOnlyDirectus } from "../../api/schedule_mng";
import { Me } from "../../api/users";
import { CreateMNGShift, DeleteShift } from "../../api/mng_shift";
import { OpentypeShiftGet } from "../../api/type_shift";
import { GetApprove, Approve } from "../../api/approved_mng";

import { DirectorLevel, TYLevel, HRLevel } from "../../constants";
import { GetReportMNG } from "../../api/report";

const ScheduleMNGOnlyDirectus = ({ token }) => {
  const [user, setUser] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [tableSchedule, setTableSchedule] = useState();
  const [endRenderScheduleTable, setEndRenderScheduleTable] = useState();
  const [addForm, setAddForm] = useState({
    name: "",
    start: 0,
    end: 0,
    userId: 0,
    date: "",
    index: 0,
    typeShiftId: 1,
  });
  const [deleteForm, setDeleteForm] = useState({ MNGShiftId: 0, userId: 0 });
  const [infoMessage, setInfoMessage] = useState("");
  const [openTypeShiftList, setOpenTypeShiftList] = useState([]);
  const [tableHours, setTableHours] = useState();
  const [bodyModal, setBodyModal] = useState();
  const [haveShiftOrNo, setHaveShiftOrNo] = useState(true);

  const [dataApprove, setDataApprove] = useState();
  const [tableApprove, setTableApprove] = useState();
  const [userApprove, setUserApprove] = useState({
    status_id: "1",
    comment: "",
  });
  const [arrayDate, setArrayDate] = useState([]);
  const [accessLevelUser, setAccessLevelUser] = useState();

  const NameShift = ["МС", "МР", "Инвен", "Пипл", "Админ"];

  const [startDateDownload, setStartDateDownload] = useState();
  const [endDateDownload, setEndDateDownload] = useState();
  const [approveMessage, setApproveMessage] = useState("");

  const loadTypeShift = async () => {
    try {
      const response = await Me(token);
      console.log(response);
      setUser(response);

      const statusShits = await OpentypeShiftGet(token);
      console.log(statusShits);
      setOpenTypeShiftList(statusShits);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadTypeShift();
  }, [token]);

  function selectDate(event) {
    const date = event.target.value;
    const selectDateInput = new Date(event.target.value);
    setArrayDate(getFormattedMonthDates(selectDateInput));
    setSelectedDate(date);
  }

  async function getScheduleMNG() {
    const data = await GetScheduleMNGOnlyDirectus(token, selectedDate);
    setTableSchedule(data);
    renderScheduleTable(data);
    renderHoursTable(data);
  }

  async function haveShift(shift, dayIndex) {
    setHaveShiftOrNo(true);
    setDeleteForm({
      MNGShiftId: shift.id,
      userId: shift.user_id,
      index: dayIndex,
      shift: shift,
    });
    setInfoMessage();
    setBodyModal(renderModalHaveShift(shift));
  }

  function notHaveShift(employee, index) {
    setHaveShiftOrNo(false);
    const selectedDateDate = new Date(selectedDate);
    selectedDateDate.setDate(index);
    setAddForm({
      ...addForm,
      userId: employee.user_id,
      date: selectedDateDate.toISOString().split("T")[0],
      index: index,
    });
    setInfoMessage();
    setBodyModal(
      <div className="modal-body">
        <div className="name">
          Название смены
          <select
            className="form-select"
            defaultValue={1}
            onChange={(e) =>
              setAddForm({ ...addForm, typeShiftId: parseInt(e.target.value) })
            }
          >
            <option key={1} value={1}>
              Не выбрано
            </option>
            {NameShift.map((shift) => (
              <option key={shift} value={shift}>
                {shift}
              </option>
            ))}
          </select>
          {/* <input
            type="text"
            className="form-control"
            onChange={(e) => setAddForm({ ...addForm, name: e.target.value })}
            value={addForm.name}
          /> */}
        </div>
        Старт и конец смены
        <div className="hours input-group">
          <input
            type="text"
            className="form-control"
            onChange={(e) =>
              setAddForm({ ...addForm, start: Number(e.target.value) })
            }
            value={addForm.start}
          />
          <input
            type="text"
            className="form-control"
            onChange={(e) =>
              setAddForm({ ...addForm, end: Number(e.target.value) })
            }
            value={addForm.end}
          />
        </div>
        <div className="open-type-shift">
          <select
            className="form-select"
            defaultValue={1}
            onChange={(e) =>
              setAddForm({ ...addForm, typeShiftId: parseInt(e.target.value) })
            }
          >
            <option key={1} value={1}>
              Не выбрано
            </option>
            {openTypeShiftList.map((shift) => (
              <option key={shift.id} value={shift.id}>
                {shift.name}
              </option>
            ))}
          </select>
        </div>
        <div className="">{infoMessage}</div>
        <button className="btn" onClick={createShift}>
          Сохранить
        </button>
      </div>
    );
  }

  function renderScheduleTable(data) {
    // console.log(data)
    const selectedDateDate = new Date(selectedDate);
    const year = selectedDateDate.getFullYear();
    const month = selectedDateDate.getMonth();

    // Получаем количество дней в месяце
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    // Массив названий дней недели
    const weekDays = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];
    // Создаем первую строку с числами месяца
    const firstRow = [
      <td key="position" rowSpan={2}>
        Должность
      </td>,
      <td
        key="name"
        rowSpan={2}
        style={{
          position: "sticky",
          left: "-1px",
          // border: "1px solid #dee2e6",
          zIndex: 9,
          boxShadow: `
    inset 1px 0 0 0 rgb(222 226 230),    /* левая граница */
    inset -1px 0 0 0 rgb(222 226 230),   /* правая граница */
    inset 0 -1px 0 0 rgb(222 226 230)    /* нижняя граница */
    /* верхняя граница отсутствует */
  `,
        }}
      >
        Фамилия Имя
      </td>,
    ];
    // Создаем вторую строку с днями недели
    const secondRow = [];
    // Заполняем дни месяца и дни недели
    for (let day = 1; day <= daysInMonth; day++) {
      const currentDate = new Date(year, month, day);
      const dayOfWeek = currentDate.getDay(); // 0 - воскресенье, 6 - суббота
      const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
      // Добавляем число месяца в первую строку
      firstRow.push(
        <th
          key={`day-${day}`}
          colSpan={1}
          style={{
            backgroundColor: isWeekend ? "#f0f0f0" : "white",
            fontWeight: "bold",
          }}
        >
          {day}
        </th>
      );

      // Добавляем день недели во вторую строку
      secondRow.push(
        <th
          key={`weekday-${day}`}
          style={{
            backgroundColor: isWeekend ? "#e0e0e0" : "white",
            color: isWeekend ? "#666" : "black",
            fontSize: "12px",
          }}
        >
          {weekDays[dayOfWeek]}
        </th>
      );
    }

    // Функция для отображения смены
    const renderShift = (shift, dayIndex, employee) => {
      if (!shift) {
        return (
          <td
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
            key={`shift-${employee.user_id}-${dayIndex}`}
            style={{
              cursor: "pointer",
              backgroundColor: "#f8f9fa",
              textAlign: "center",
              color: "#6c757d",
              padding: "8px 4px",
              border: "1px solid #dee2e6",
            }}
            onClick={() => notHaveShift(employee, dayIndex + 1)}
          >
            Нет смены
          </td>
        );
      }

      if (shift.type_shift_id != 1) {
        let typeShiftName;
        for (let tp of openTypeShiftList) {
          if (tp.id == shift.type_shift_id) {
            typeShiftName = tp.name;
          }
          // console.log(tp)
        }
        return (
          <td
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
            key={`shift-${shift.user_id}-${dayIndex}`}
            style={{
              backgroundColor: "#d8d8d8ff",
              textAlign: "center",
              padding: "8px 4px",
              border: "1px solid #dee2e6",
              cursor: "pointer",
            }}
            onClick={() => haveShift(shift, dayIndex + 1)}
          >
            <div style={{ fontSize: "12px", color: "#495057" }}>
              {typeShiftName}
            </div>
            {/* {shift.hours && (
                    <div style={{ fontSize: '11px', color: '#6c757d', marginTop: '2px' }}>
                        {shift.hours} ч.
                    </div>
                )} */}
          </td>
        );
      }

      return (
        <td
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
          key={`shift-${shift.user_id}-${dayIndex}`}
          style={{
            backgroundColor: "#e8f5e8",
            textAlign: "center",
            padding: "8px 4px",
            border: "1px solid #dee2e6",
            cursor: "pointer",
          }}
          onClick={() => haveShift(shift, dayIndex + 1)}
        >
          <div style={{ fontWeight: "bold", fontSize: "14px" }}>
            {shift.name}
          </div>
          <div style={{ fontSize: "12px", color: "#495057" }}>
            {shift.start} - {shift.end}
          </div>
          {shift.hours && (
            <div
              style={{ fontSize: "11px", color: "#6c757d", marginTop: "2px" }}
            >
              {shift.hours} ч.
            </div>
          )}
        </td>
      );
    };

    // Создаем тело таблицы
    const tbody = data.table.map((employee, empIndex) => (
      <tr key={`emp-${employee.surname}-${empIndex}`}>
        <td
          style={{
            padding: "12px",
            backgroundColor: "#f8f9fa",
            fontWeight: "bold",
            border: "1px solid #dee2e6",
            textAlign: "center",
          }}
        >
          {employee.post_name}
        </td>
        <td
          style={{
            position: "sticky",
            left: "-1px",
            boxShadow: `
    inset 1px 0 0 0 rgb(222 226 230),    /* левая граница */
    inset -1px 0 0 0 rgb(222 226 230),   /* правая граница */
    inset 0 -1px 0 0 rgb(222 226 230)    /* нижняя граница */
    /* верхняя граница отсутствует */
  `,
            padding: "12px",
            backgroundColor: "#f8f9fa",
            // border: "1px solid #dee2e6",
            textAlign: "center",
          }}
        >
          {employee.surname} {employee.name}
        </td>
        {employee.shifts.map((shift, dayIndex) =>
          renderShift(shift, dayIndex, employee)
        )}
      </tr>
    ));

    const thead = [
      <tr key="row1">{firstRow}</tr>,
      <tr key="row2">{secondRow}</tr>,
    ];

    setEndRenderScheduleTable(
      <table
        className="table table-bordered table-responsive"
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontFamily: "Arial, sans-serif",
          fontSize: "14px",
        }}
      >
        <thead>{thead}</thead>
        <tbody>{tbody}</tbody>
      </table>
    );
  }

  async function createShift() {
    const data = await CreateMNGShift(
      token,
      addForm.userId,
      addForm.date,
      addForm.start,
      addForm.end,
      addForm.name,
      addForm.typeShiftId
    );
    console.log(data);
    if (data.detail) {
      setInfoMessage(<div style={{ color: "red" }}>{data.detail}</div>);
      return;
    }
    // console.log(tableSchedule)
    setDeleteForm({
      MNGShiftId: data.id,
      userId: data.user_id,
      index: addForm.index,
    });
    const updatedTableSchedule = { ...tableSchedule };

    for (let user of updatedTableSchedule.table) {
      if (user.user_id == addForm.userId) {
        // Создаем копию массива смен
        const updatedShifts = [...user.shifts];
        updatedShifts[addForm.index - 1] = data; // index - 1 т.к. дни с 1, а индексы с 0
        user.shifts = updatedShifts;
      }
    }
    setInfoMessage(<div style={{ color: "green" }}>Готово!</div>);
    setTableSchedule(updatedTableSchedule); // ✅ Устанавливаем обновленный объект
    renderScheduleTable(updatedTableSchedule); // ✅ Перерисовываем таблицу
    renderHoursTable(updatedTableSchedule);
  }

  async function deleteShift() {
    console.log(deleteForm, 89);
    const data = await DeleteShift(token, deleteForm.MNGShiftId);
    if (data.detail) {
      setInfoMessage(<div style={{ color: "red" }}>{data.detail}</div>);
      return;
    }
    const updatedTableSchedule = { ...tableSchedule };
    setAddForm({
      ...addForm,
      userId: data.user_id,
      date: data.date,
      index: deleteForm.index,
    });
    for (let user of updatedTableSchedule.table) {
      if (user.user_id == deleteForm.userId) {
        // Создаем копию массива смен
        const updatedShifts = [...user.shifts];

        // for (let shift in user.shifts){
        //     console.log(shift)
        // }
        // Исправление: используем deleteForm.index без -1
        // поскольку в notHaveShift мы уже сохраняем index с 0
        console.log(deleteForm.index);
        console.log(updatedShifts[deleteForm.index - 1]);
        updatedShifts[deleteForm.index - 1] = null;

        user.shifts = updatedShifts;
      }
    }
    setInfoMessage(<div style={{ color: "green" }}>Удалено!</div>);
    setTableSchedule(updatedTableSchedule);
    renderScheduleTable(updatedTableSchedule);
    renderHoursTable(updatedTableSchedule);
  }

  function renderShiftHours(user) {
    let info = {
      hours: 0,
      shifts: 0,
      weekend: 0,
      sickDays: 0,
      vacations: 0,
      norma: 165,
      different: 165,
      BKHours: 0,
    };

    for (let shift of user.shifts) {
      if (shift) {
        info.hours += shift.hours;
        if (shift.hours > 1) info.shifts += 1;
        // if (isWeekend(shift.date) )  info.weekend += 1

        if (shift.type_shift_id != 1) {
          switch (shift.type_shift_id) {
            case 4:
              info.weekend += 1;
              break;
            case 5:
              if (!isWeekend(shift.date)) {
                info.different -= 8;
              }
              info.sickDays += 1;
              break;
            case 6:
              info.vacations += 1;
              if (!isWeekend(shift.date)) {
                info.different -= 8;
              }
              break;
          }
        }
      }
    }
    info.different -= info.hours; //- (info.vacations * 8) - (info.sickDays * 8)

    return (
      <tr>
        <td>{user.name}</td>
        <td>{info.hours}</td>
        <td>{info.shifts}</td>
        <td>{info.weekend}</td>
        <td>{info.sickDays}</td>
        <td>{info.vacations}</td>
        <td>{info.norma}</td>
        <td>{info.different}</td>
        <td>{info.BKHours}</td>
      </tr>
    );
  }

  function renderHoursTable(data) {
    setTableHours(
      <tbody>{data.table.map((user) => renderShiftHours(user))}</tbody>
    );
  }

  function renderModalHaveShift(shift) {
    if (!shift) {
      return;
    }
    let body;
    let bk_body;
    if (shift.type_shift_id == 1) {
      body = (
        <div className="info">
          <div className="hours">Кол-во часов: {shift.hours}</div>
          <div className="hours">Начало {shift.start}</div>
          <div className="hours">Конец: {shift.end}</div>
          <div className="hours">Название смены: {shift.name}</div>
          <div className="hours">Сотрудник: {shift.user_id}</div>
          <div className="hours">Тип смены: Обычная</div>
          <div className="date">Дата: {shift.date}</div>
        </div>
      );
      if (shift.bk_hours) {
        bk_body = <div className="hours">{shift.bk_hours}</div>;
      }
    } else if (shift.type_shift_id > 1) {
      let nameTypeShift;
      for (let typeShift of openTypeShiftList) {
        if (typeShift.id == shift.type_shift_id) {
          nameTypeShift = typeShift.name;
        }
      }
      body = (
        <div className="info">
          <div className="hours">Сотрудник: {shift.user_id}</div>
          <div className="hours">Тип смены: {nameTypeShift}</div>
          <div className="date">Дата: {shift.date}</div>
        </div>
      );
    }
    return (
      <div className="modal-body">
        {body}
        {infoMessage}
        {/* <button className="btn" onClick={deleteShift}>
          Удалить
        </button> */}
      </div>
    );
  }

  async function loadAppored() {
    const data = await GetApprove(token, arrayDate[0], arrayDate.at(-1));
    console.log(arrayDate[0], arrayDate.at(-1));
    setDataApprove(data);
    setTableApprove(renderApprove(data));
    if (accessLevelUser == HRLevel) {
      userApprove["comment"] = data["HR_comment"];
      userApprove["comment"] = data["HR_status"];
    } else if (accessLevelUser == TYLevel) {
      userApprove["comment"] = data["TY_comment"];
      userApprove["status_id"] = data["TY_status"];
    } else if (accessLevelUser == DirectorLevel) {
      userApprove["comment"] = data["director_comment"];
      userApprove["status_id"] = data["director_status"];
    }
  }

  function renderApprove(data) {
    const statusTextById = {
      1: "Не согласовано",
      2: "На доработке",
      3: "Согласовано!",
    };
    const red = "red";
    const yellow = "yellow";
    const green = "green";
    let direcorColor = "";
    let TYColor = "";
    let HRColor = "";
    if (data.HR_status == null) {
      HRColor = red;
    } else if (data.HR_status == 2) {
      HRColor = yellow;
    } else if (data.HR_status == 3) {
      HRColor = green;
    }
    ///
    if (data.TY_status == null || data.TY_status == 1) {
      TYColor = red;
    } else if (data.TY_status == 2) {
      TYColor = yellow;
    } else if (data.TY_status == 3) {
      TYColor = green;
    }
    ///
    if (data.director_status == null || data.director_status == 1) {
      direcorColor = red;
    } else if (data.director_status == 2) {
      direcorColor = yellow;
    } else if (data.director_status == 3) {
      direcorColor = green;
    }
    return (
      <table className="table table-bordered">
        <thead>
          <tr className="d-flex text-center">
            <th className="col-md-4 text-center">Директор</th>
            <th className="col-md-4">Территориальный управляющий</th>
            <th className="col-md-4">HR-менеджер</th>
          </tr>
        </thead>
        <tbody>
          <tr className="d-flex text-center">
            <td className="col-md-4" style={{ background: direcorColor }}></td>
            <td className="col-md-4" style={{ background: TYColor }}></td>
            <td className="col-md-4" style={{ background: HRColor }}></td>
          </tr>
          <tr className="d-flex text-center">
            <td className="col-md-4">{data.director_surname_name}</td>
            <td className="col-md-4">{data.TY_surname_name}</td>
            <td className="col-md-4">{data.HR_surname_name}</td>
          </tr>
          <tr className="d-flex text-center">
            <td className="col-md-4">{statusTextById[data.director_status]}</td>
            <td className="col-md-4">{statusTextById[data.TY_status]}</td>
            <td className="col-md-4">{statusTextById[data.HR_director]}</td>
          </tr>
          <tr className="d-flex text-center">
            <td className="col-md-4">{data.director_comment}</td>
            <td className="col-md-4">{data.TY_comment}</td>
            <td className="col-md-4">{data.HR_comment}</td>
          </tr>
          <tr>
            <td
              className="text-center"
              colSpan={3}
              data-bs-toggle="modal"
              data-bs-target="#approvalModal"
            >
              Изменить
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  function selectStageApprove(event) {
    console.log(userApprove);
    setUserApprove({ ...userApprove, status_id: event.target.value });
  }

  function onChangeCommentApprove(event) {
    setUserApprove({ ...userApprove, comment: event.target.value });
  }

  async function approveSchedule(event) {
    if (arrayDate.length == 0) {
      setApproveMessage(<p style={{ color: "red" }}>Не выбрана дата!</p>);
      setUserApprove({
        status_id: "1",
        comment: "",
      });
      return;
    }
    const data = await Approve(
      token,
      arrayDate[0],
      arrayDate.at(-1),
      userApprove["status_id"],
      userApprove["comment"]
    );
    if (data.detail) {
      setApproveMessage(<p style={{ color: "red" }}>{data.detail}</p>);
      setUserApprove({
        status_id: "1",
        comment: "",
      });
      return;
    }
    setApproveMessage(<p style={{ color: "green" }}>Успешно!</p>);
    setTableApprove(renderApprove(data));
  }

  async function download() {
    const response = await GetReportMNG(
      token,
      startDateDownload,
      endDateDownload
    );
    console.log(response);

    // Получаем blob из данных ответа axios
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Создание URL для blob
    const url = window.URL.createObjectURL(blob);

    // Создание временной ссылки для скачивания
    const link = document.createElement("a");
    link.href = url;

    // Получение имени файла из headers
    const contentDisposition = response.headers["content-disposition"];
    let filename = "food_report.xlsx";

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }

    link.download = filename;

    // Автоматическое скачивание
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Очистка URL
    window.URL.revokeObjectURL(url);
  }

  return (
    <div className="container-fluid">
      <div className="accordion" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Выбор даты
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <input
                type="date"
                className="form-control"
                name=""
                id=""
                onChange={selectDate}
              />
              <p className="text-center">
                Выберите любой день недели и автоматический загрузится недеделя
                с понедельника до воскресения
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
              onClick={getScheduleMNG}
            >
              Расписание
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <div className="table-responsive">{endRenderScheduleTable}</div>
              <div className="table-hours">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Сотрудник</th>
                      <th>Часы</th>
                      <th>Смен</th>
                      <th>Выходных</th>
                      <th>Больничных</th>
                      <th>Отпусков</th>
                      <th>Норма</th>
                      <th>Отклонения</th>
                      <th>БК часов</th>
                    </tr>
                  </thead>
                  {tableHours}
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="accordion-item">
          <h2 className="accordion-header" id="headingFour">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
              // onClick={loadAppored}
            >
              Скачать расписание
            </button>
          </h2>
          <div
            id="collapseFour"
            className="accordion-collapse collapse"
            aria-labelledby="headingFour"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <div className="mb-3">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Начало периода
                </label>
                <input
                  type="date"
                  className="form-control"
                  name=""
                  id="exampleFormControlInput1"
                  value={startDateDownload}
                  onChange={(e) => setStartDateDownload(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Конец периода
                </label>
                <input
                  type="date"
                  className="form-control"
                  name=""
                  id=""
                  value={endDateDownload}
                  onChange={(e) => setEndDateDownload(e.target.value)}
                />
              </div>
              <button className="btn" onClick={download}>
                Скачать xlsx
              </button>
            </div>
          </div>
        </div> */}
      </div>
      <div
        className="modal fade"
        id="staticBackdrop"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5 className="modal-title text-center" id="staticBackdropLabel">
                Информация
              </h5>
            </div>
            {haveShiftOrNo ? (
              renderModalHaveShift(deleteForm.shift)
            ) : (
              // <div className="te">fdsfsa</div>
              <div className="modal-body">
                <div className="name">
                  Название смены
                  <select
                    className="form-select"
                    defaultValue={1}
                    value={addForm.name}
                    onChange={(e) =>
                      setAddForm({
                        ...addForm,
                        name: e.target.value,
                      })
                    }
                  >
                    <option key={1} value={1}>
                      Не выбрано
                    </option>
                    {NameShift.map((shift) => (
                      <option key={shift} value={shift}>
                        {shift}
                      </option>
                    ))}
                  </select>
                  {/* <input
                    type="text"
                    className="form-control"
                    onChange={(e) =>
                      setAddForm({ ...addForm, name: e.target.value })
                    }
                    value={addForm.name}
                  /> */}
                </div>
                Старт и конец смены
                <div className="hours input-group">
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) =>
                      setAddForm({ ...addForm, start: Number(e.target.value) })
                    }
                    value={addForm.start}
                  />
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) =>
                      setAddForm({ ...addForm, end: Number(e.target.value) })
                    }
                    value={addForm.end}
                  />
                </div>
                <div className="open-type-shift">
                  <select
                    className="form-select"
                    defaultValue={1}
                    value={addForm["typeShiftId"]}
                    onChange={(e) =>
                      setAddForm({
                        ...addForm,
                        typeShiftId: parseInt(e.target.value),
                      })
                    }
                  >
                    <option key={1} value={1}>
                      Не выбрано
                    </option>
                    {openTypeShiftList.map((shift) => (
                      <option key={shift.id} value={shift.id}>
                        {shift.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="">{infoMessage}</div>
                {/* <button className="btn" onClick={createShift}>
                  Сохранить
                </button> */}
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="approvalModal"
        tabIndex="-1"
        aria-labelledby="approvalModelLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h1 className="modal-title fs-5" id="approvalModelLabel">
                Согласование
              </h1>
            </div>
            <div className="modal-body">
              <div className="select text-center">
                Этап согласования
                <select
                  className="form-select"
                  aria-label="Default select example"
                  onChange={selectStageApprove}
                  value={userApprove["status_id"]}
                >
                  <option value="1">Не согласовано</option>
                  <option value="2">На доработке</option>
                  <option value="3">Согласовано</option>
                </select>
              </div>
              <div className="coment text-center">
                Комментарий
                <textarea
                  name=""
                  id=""
                  className="form-control"
                  onChange={onChangeCommentApprove}
                  value={userApprove["comment"]}
                ></textarea>
              </div>
            </div>
            <div className="approve-message text-center">{approveMessage}</div>
            <div className="modal-footer justify-content-center">
              <button type="button" className="btn" onClick={approveSchedule}>
                Сохранить
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleMNGOnlyDirectus;

function isWeekend(dateString) {
  const day = new Date(dateString).getDay();
  return day === 0 || day === 6;
}

function getFormattedMonthDates(inputDate) {
  const date = new Date(inputDate);

  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

  return [formatDate(firstDay), formatDate(lastDay)];
}

const formatDate = (dateObj) => {
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
